"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundamentalsPeriodTypeEnum = void 0;
var FundamentalsPeriodTypeEnum;
(function (FundamentalsPeriodTypeEnum) {
    FundamentalsPeriodTypeEnum["Quarterly"] = "quarterly";
    FundamentalsPeriodTypeEnum["Yearly"] = "yearly";
})(FundamentalsPeriodTypeEnum = exports.FundamentalsPeriodTypeEnum || (exports.FundamentalsPeriodTypeEnum = {}));
//# sourceMappingURL=fundamentals-period-type-enum.js.map